import React from 'react';
import PropTypes from 'prop-types';
import Reflux from 'reflux';
import AuditLogLicenseActions from './AuditLogLicenseActions';
import AuditLogLicenseStore from './AuditLogLicenseStore';
import AuditLogLicenseStatus from './AuditLogLicenseStatus';

const ArchiveLicenseStatusContainer = React.createClass({
  propTypes: {
    summary: PropTypes.bool,
  },

  mixins: [Reflux.connect(AuditLogLicenseStore, 'licenseStatus')],

  componentDidMount() {
    AuditLogLicenseActions.getLicenseStatus();
  },

  render() {
    if (this.state.licenseStatus.loading) {
      return null;
    }

    return <AuditLogLicenseStatus licenseStatus={this.state.licenseStatus} summary={this.props.summary} />;
  },
});

export default ArchiveLicenseStatusContainer;



// WEBPACK FOOTER //
// ./src/web/AuditLogLicenseStatusContainer.jsx